export default __webpack_public_path__ + "images/calendar-green-icon.svg?14d97af6668afe90a24be736ac83b78c";